import { FC, useMemo } from 'react';

import { BoxProps, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { useField } from 'formik';

import { Flex } from 'src/components/Flex';

type OptionTypes = {
    label: string;
    value: string | number | boolean;
};

interface CustomRadioGroup {
    label?: string;
    name: string;
    boxStyling?: BoxProps;
    options: OptionTypes[];
    disabled?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
}

export const CustomRadioGroup: FC<CustomRadioGroup> = ({
    label,
    name,
    boxStyling,
    options,
    disabled,
    onChange,
}) => {
    const [{ value }, { touched, error }, { setValue }] = useField(name);

    const hasError = useMemo(() => touched && error, [touched, error]);

    const handleChangeDefault = (e) => {
        setValue(e.target.value);
    };

    const borderColor = hasError ? 'red' : '#F39E4E';

    return (
        <Flex flexDirection="column" flex={0.49} {...boxStyling}>
            {label && (
                <FormLabel sx={{ marginBottom: '8px', color: '#000', fontWeight: 600 }}>
                    {label}
                </FormLabel>
            )}

            <RadioGroup value={value} onChange={onChange ?? handleChangeDefault}>
                <Flex>
                    {options.map((el, index) => (
                        <FormControlLabel
                            key={`radio-${index}`}
                            value={el.value}
                            label={el.label}
                            disabled={disabled}
                            control={<Radio sx={{ borderColor }} data-testid={`radio-${index}`} />}
                        />
                    ))}
                </Flex>
            </RadioGroup>

            {hasError ? <label className="error">{error}</label> : null}
        </Flex>
    );
};
